<template>
  <div class="bg-box">
    <top-title name="权益发放" style="min-width: 980px"></top-title>
    <div class="tab-box">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="变更积分" name="0">
          <div class="tab-item">
            <jd-tips margin="0">
              <div>
                说明：支持批量发放/扣减积分
              </div>
            </jd-tips>
            <div class="content-box">
              <changeIntegral :permissions="permissions" v-if="activeName=='0'"></changeIntegral>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="批量发券" name="1">
          <div class="tab-item">
            <jd-tips margin="0"
              >说明：通过输入PIN、导入pin的方式进行定向发券</jd-tips
            >
            <div class="content-box">
              <batchPublish
                v-if="activeName=='1'"
                :showCreateDialog="showCreateDialog"
                :selectCrowdType="selectCrowdType"
                @resetDialog="resetDialog"
                :permissions="permissions"
              ></batchPublish>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="批量发放京豆" name="2">
          <div class="tab-item">
            <jd-tips margin="0"
              >说明：通过输入PIN、导入pin的方式进行定向发京豆，通常用于店铺邀好评、下单等活动场景的权益发放</jd-tips
            >
            <div class="content-box">
              <batchBeans :permissions="permissions" v-if="activeName=='2'"></batchBeans>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="批量发放红包" name="3">
          <div class="tab-item">
            <jd-tips margin="0"
              >说明：通过输入PIN、导入pin的方式进行定向发红包，通常用于店铺邀好评、下单等活动场景的权益发放</jd-tips
            >
            <div class="content-box">
              <batchRedEnvelope :permissions="permissions" v-if="activeName=='3'"></batchRedEnvelope>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import jdTips from "@/components/common/jdTips.vue";
import topTitle from "../../../components/top-title";
import changeIntegral from "./components/changeIntegral.vue";
import batchPublish from "./components/batchPublish.vue";
import batchBeans from "./components/batchBeans.vue";
import batchRedEnvelope from "./components/batchRedEnvelope.vue";

export default {
  components: {
    topTitle,
    jdTips,
    changeIntegral,
    batchPublish,
    batchBeans,
    batchRedEnvelope,
  },
  data() {
    return {
      activeName: "0",
      showCreateDialog: false,
      selectCrowdType: 2,
    };
  },
  mounted() {},
  computed: {
    permissions() {
      // 权限列表
      return this.$store.getters.loginUserInfo.permissions;
    },
  },
  methods: {
    resetDialog(val) {
      this.showCreateDialog = false;
    },
    handleClick(tab, event) {
      this.activeName = tab.name;
    },
  },
};
</script>

<style scoped lang="scss">
.bg-box {
  display: flex;
  flex-direction: column;
  background: #ffffff;
  height: 100%;
  margin: 24px;
  .tab-box {
    padding: 0 16px;
    .tab-item {
      padding: 16px 0;
      .content-box {
        margin-top: 20px;
      }
    }
  }
  .mb16 {
    margin-bottom: 16px;
  }
}
</style>
